"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieServiceImpl = void 0;
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const cookieConsentPreferences_1 = require("../models/cookieConsentPreferences");
class CookieServiceImpl {
    constructor(cookieConsentPreferenceName) {
        this.getAllCookies = () => {
            return this.cookies;
        };
        this.addCookieConsentUpdateHandlers = (textId, cookieConsentUpdateHandler) => {
            this.cookieConsentUpdateHandlers[textId] = cookieConsentUpdateHandler;
        };
        this.getCookieConsentPreferences = () => {
            const cookieConsentPreferences = this.cookies.get(this.cookieConsentPreferenceName);
            if (cookieConsentPreferences)
                return cookieConsentPreferences;
            else
                return null;
        };
        this.setCookieConsentPreferences = (consent) => {
            this.cookies.set(this.cookieConsentPreferenceName, JSON.stringify(consent), {
                path: "/",
                expires: this.offsetYear(1),
            });
            this.triggerCookieConsentUpdateHandlers(consent);
        };
        this.removeAllCookies = () => {
            const allCookies = this.cookies.getAll();
            for (const key of Object.keys(allCookies)) {
                this.cookies.remove(key, { path: "/" });
            }
            this.triggerCookieConsentUpdateHandlers(cookieConsentPreferences_1.DEFAULT_COOKIE_CONSENT_PREFERENCES);
        };
        this.cookies = new universal_cookie_1.default();
        this.cookieConsentPreferenceName = cookieConsentPreferenceName;
        this.cookieConsentUpdateHandlers = {};
    }
    triggerCookieConsentUpdateHandlers(consent) {
        Object.entries(this.cookieConsentUpdateHandlers).forEach(([, method]) => method(consent));
    }
    offsetYear(year) {
        const date = new Date();
        date.setFullYear(date.getFullYear() + year);
        return date;
    }
}
exports.CookieServiceImpl = CookieServiceImpl;
//# sourceMappingURL=cookieServiceImpl.js.map